module.exports = __webpack_public_path__ + "img/googleplay.6024034b.png";